import { toast } from 'react-toastify';
import { call } from 'redux-saga/effects';
import React from 'react';
import { ErrorToast } from '../error-toast/ErrorToast';

export function* setToastErrorSaga(action) {
    const { message, errorCode, sessionEnded } = action.payload;

    // A session that the server ended is said on the login page, once (see makeErrorPayload)
    if (sessionEnded) {
        return;
    }

    // The same error while it is still showing is shown once: a screen that makes ten reads at once gets ten of the same answer
    yield call(toast, <ErrorToast message={message} errorCode={errorCode} />, {
        className: 'toast-error-container',
        progressClassName: 'error-progress-bar',
        toastId: `error:${errorCode || ''}:${message}`
    });
}

export function* setToastSuccessSaga(action) {
    const { message } = action.payload;
    yield call(toast.info, message); //todo: Hack
}
